export const extraHotkeys = [
	{
		menuLabel: 'Auto',
		hotkey: {
			altKey: false,
			ctrlKey: false,
			hotkey: 'F5',
			metaKey: false,
			shiftKey: false,
		},
	},
	{
		menuLabel: 'Sigmoid',
	},
];

export const windowPresets = {
	brain: { name: 'Brain', windowWidth: 70, windowCenter: 30 },
	bone: { name: 'Bone', windowWidth: 2000, windowCenter: 500 },
	abdomen: { name: 'Abdomen', windowWidth: 400, windowCenter: 40 },
	softTissue: { name: 'Soft Tissue', windowWidth: 350, windowCenter: 50 },
	liver: { name: 'Liver', windowWidth: 160, windowCenter: 60 },
	lung: { name: 'Lung', windowWidth: 1500, windowCenter: -600 },
	mediastinum: { name: 'Mediastinum', windowWidth: 500, windowCenter: 50 },
	stroke: { name: 'Stroke', windowWidth: 30, windowCenter: 30 },
	cta: { name: 'CTA', windowWidth: 600, windowCenter: 170 },
	seeds: { name: 'Seeds', windowWidth: 400, windowCenter: 800 },
};

export const PRESETS = Object.values(windowPresets).map(preset => ({
	menuLabel: preset.name,
	...preset,
}));
